<template>
    <div :class="componentClass" style="min-height: 50px">
        <div class="float-left col-sm-1">
            <i class="k-icon k-i-pin pointer dashboard-btn-style"
               @click.stop="pinToDashboard"
               v-if="showPinButton && !isPinnedToDashboard"
               :title="pinTooltipText"></i>
            <i class="k-icon k-i-unpin pointer dashboard-btn-style"
               @click.stop="unpinFromDashboard"
               v-if="isPinnedToDashboard"
               :title="unpinTooltipText"></i>
        </div>

        <div class="float-left col-sm-8" v-if="showHeader">
            <page-title :showHeadful="showHeadful" :title="($t(headerTitle))"></page-title>
        </div>

        <div class="float-right">
            <i class="fas fa-search-plus pointer dashboard-btn-style"
               @click.stop="resize(12)"
               v-if="showResizeIcon && size === 6"
               data-toggle="tooltip"
               :title="maximizeTooltipText"></i>
            <i class="fas fa-search-minus pointer dashboard-btn-style"
               @click.stop="resize(6)"
               v-if="showResizeIcon && size === 12"
               data-toggle="tooltip"
               :title="minimizeTooltipText"></i>
            <i class="fas fa-times pointer dashboard-btn-style"
               @click.stop="hide"
               v-if="showHideButton"
               data-toggle="tooltip"
               :title="hideTooltipText"></i>
        </div>
    </div>
</template>

<script>
    import http from '../../services/http.service';
    import PageTitle from '../common/PageTitle';
    export default {
        name: "controlBtnsTemplate",
        components: {
            PageTitle
        },
        props: {
            componentName: {
                default: '',
                type: String
            },
            isDynamicRegister: {
                default: false,
                type: Boolean
            },
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            headerTitle: {
                default: 'No title',
                type: String
            },
            componentClass: {
                default: 'No title',
                type: String
            },
            showHeader: {
                default: true,
                type: Boolean
            },
            showHeadful: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                isPinnedToDashboard: true, // default value,
                pinTooltipText: this.$t('buttons.pinToDashboard.tooltipText'),
                unpinTooltipText: this.$t('buttons.unpinFromDashboard.tooltipText'),
                maximizeTooltipText: this.$t('buttons.maximize.tooltipText'),
                minimizeTooltipText: this.$t('buttons.minimize.tooltipText'),
                hideTooltipText: this.$t('buttons.hide.tooltipText')
            };
        },
        mounted() {
            this.checkIfPinnedToDashboard();
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        methods: {
            pinToDashboard() {
                http.get(`/api/personalization/${this.componentName}/pinToDashboard/${this.isDynamicRegister}`)
                    .then(response => {
                        this.isPinnedToDashboard = true;
                        this.$emit('pinned', this.componentName)
                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            unpinFromDashboard() {
                http.get(`/api/personalization/${this.componentName}/unpinFromDashboard/${this.isDynamicRegister}`)
                    .then(response => {
                        this.isPinnedToDashboard = false;
                        this.$emit('unpinned', this.componentName)
                        this.$vs.notify({
                            title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                            text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    }).catch(error => {
                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            checkIfPinnedToDashboard() {
                http.get('/api/personalization/' + this.componentName + '/isPinned')
                    .then(response => {
                        this.isPinnedToDashboard = response.data.isPinned;
                    }).catch(error => {
                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            resize(size) {
                http.get('/api/personalization/' + this.componentName + '/setSize/' + size)
                    .then(response => {
                        this.$emit('resize', this.componentName, size)
                    }).catch(error => {
                        this.$vs.notify({
                            title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            hide() {
                this.$emit('hide', this.componentName)
            }
        }
    };
</script>

<style scoped>
    .dashboard-btn-style{
        padding-right: 5px;
        font-size: 150%;
    }
</style>
